/**
 * Centralized storage utilities
 * Combines localStorage and cookie operations with SSR safety
 */

// ============================================================================
// LocalStorage Operations
// ============================================================================

export const safeGetItem = (key: string): string | null => {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem(key);
  }
  return null;
};

export const safeSetItem = (key: string, value: string): boolean => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(key, value);
    return true;
  }
  return false;
};

export const safeRemoveItem = (key: string): boolean => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(key);
    return true;
  }
  return false;
};

export const safeClear = (): boolean => {
  if (typeof localStorage !== 'undefined') {
    localStorage.clear();
    localStorage.setItem('language', 'ar');
    return true;
  }
  return false;
};

// ============================================================================
// Cookie Operations (Re-exported from cookie.util.ts for backward compatibility)
// ============================================================================

export { getCookie, setCookie, removeCookie } from './cookie.util';
